import { render, staticRenderFns } from "./PayModal.vue?vue&type=template&id=5015f6cc&scoped=true"
import script from "./PayModal.vue?vue&type=script&lang=js"
export * from "./PayModal.vue?vue&type=script&lang=js"
import style0 from "./PayModal.vue?vue&type=style&index=0&id=5015f6cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5015f6cc",
  null
  
)

export default component.exports